import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

Alpine.plugin(collapse);
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  const bodyElement = document.body;
  bodyElement.classList.remove('fade-out');
});

// document.querySelector('.menu-toggle')?.addEventListener('click', function () {
//   this.classList.toggle('active');
//   const pageHeader = document.querySelector('.page-header');
//   if (pageHeader) {
//     pageHeader.classList.toggle('active');
//   }
//   const mainNavigation = document.querySelector(
//     '.main-navigation'
//   ) as HTMLUListElement;
//   if (mainNavigation) {
//     mainNavigation.style.display =
//       window.getComputedStyle(mainNavigation).display === 'none'
//         ? 'block'
//         : 'none';
//   }
// });
// // Mobile menu subNav
// document.querySelectorAll('.hasChildren > span').forEach((element) => {
//   element.addEventListener('click', () => {
//     document.querySelector('.main-navigation')?.classList.add('showSubNav');
//     document.querySelector('.top-navigation')?.classList.add('showSubNav');
//     const parentElement = element.parentElement as HTMLElement | null;
//     if (parentElement) {
//       parentElement.classList.add('showSubNav');
//     }
//   });
// });

// document.querySelectorAll('.goBack').forEach((element) => {
//   element.addEventListener('click', () => {
//     document.querySelector('.main-navigation')?.classList.remove('showSubNav');
//     document.querySelector('.top-navigation')?.classList.remove('showSubNav');
//     const parents = element.closest('.hasChildren');
//     if (parents) {
//       parents.classList.remove('showSubNav');
//     }
//   });
// });

// document.querySelectorAll('.goBack').forEach((element) => {
//   const item = element as HTMLLIElement;
//   const parentElement = item.closest('.hasChildren') as HTMLLIElement;
//   if (parentElement) {
//     const parentBg = window.getComputedStyle(parentElement).backgroundColor;
//     item.style.backgroundColor = parentBg;
//   }
// });

// document.querySelectorAll('.expand').forEach((element) => {
//   element.addEventListener('click', () => {
//     element.classList.toggle('expanded');
//   });
// });
